"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var SignupContext_1 = require("../SignupContext");
var CloseBtn_1 = require("../../common/Btn/CloseBtn");
var SignupPopup = function () {
    var _a = (0, hooks_1.useContext)(SignupContext_1.SignupContext), setModalOpen = _a.setModalOpen, setMiniPopupOpen = _a.setMiniPopupOpen;
    var removeEmailPopup = function () {
        window.localStorage.setItem('completedPopup', 'true');
        setMiniPopupOpen === null || setMiniPopupOpen === void 0 ? void 0 : setMiniPopupOpen(false);
    };
    var discount = '25%';
    return ((0, preact_1.h)("div", { className: "signup-popup" },
        (0, preact_1.h)("p", { onClick: function () {
                setModalOpen === null || setModalOpen === void 0 ? void 0 : setModalOpen(true);
            }, className: "signup-popup__text signup-popup__full" },
            ' ',
            "GET ",
            discount,
            " OFF"),
        (0, preact_1.h)(CloseBtn_1.default, { closeFn: function () { return removeEmailPopup(); } })));
};
exports.default = SignupPopup;
